import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/doctor/types'
import DoctorEntity, { IDoctorProps } from '@/entities/Doctor'
import { IResponseProps } from '@/entities/Response'

export default class DoctorRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  set data(value: IResponseProps<IDoctorProps>) {
    this.store.commit(new types.Store(value))
  }

  get data(): IResponseProps<IDoctorProps> {
    return this.store.state.doctor.response
  }

  set current(value: IDoctorProps | null) {
    this.store.commit(new types.Current(value))
  }

  get current(): IDoctorProps | null {
    return this.store.state.doctor.current
  }

  get entity(): DoctorEntity {
    return new DoctorEntity(this.store.state.doctor.current)
  }

  set filter(value: string) {
    this.store.commit(new types.Filter(value))
  }

  get filter(): string {
    return this.store.state.doctor.filter
  }
}
